{
  "title": "Protection from Poison",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "1 hour",
  "description": [
    "You touch a creature. If it is poisoned, you neutralize the poison. If more than one poison afflicts the target, you neutralize one poison that you know is present, or you neutralize one at random.",
    "For the duration, the target has advantage on saving throws against being poisoned, and it has resistance to poison damage."
  ],
  "spellLists": ["artificer", "cleric", "druid", "paladin", "ranger"]
}
